<template>
  <div class="card height-equal milestones-card">
    <div class="card-header">
      <h5>Milestones</h5>
    </div>
    <div class="card-body position-relative">
      <div class="new-users">
        <template v-if="milestones_data">
          <div class="d-flex flex-column" v-for="(item, index) in milestones_data" :key="index">
            <div class="media">
              <div class="media-body">
                <h5 class="mb-0 f-w-700" v-b-toggle="'collapseicon'+index">{{item.title}}</h5>
                <p class="mr-2">{{item.description}}</p>
              </div>
              <span class="pull-right">
                <button type="button" class="btn btn-pill btn-light mr-2 btn-icon-center" v-b-tooltip.hover title="Edit" @click="openEditModal(item)">
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-pill btn-outline-light collapseicon-btn btn-icon-center" v-b-toggle="'collapseicon'+index">
                  <i class="fa fa-angle-right"></i>
                </button>
              </span>
            </div>
            <b-collapse :id="'collapseicon'+index" role="tabpanel" class="collapseicon-wrapper">
              <UserTasks :user_tasks="item.tasks"/>
            </b-collapse>
          </div>
        </template>

        <div v-else>
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert alert-primary outline alert-primary">
            <p>There are no Milestones yet</p></div>
        </div>

        <b-modal ref="edit-milestones" title="Edit Milestones" hide-footer>
          <form @submit.prevent="handleEdit">
            <div class="form-group">
              <label for="milestones-edit-title">Title</label>
              <input type="text" v-model="milestonesEdit.title" id="milestones-edit-title" name="title" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.milestonesEdit.title.$error }" />
              <div v-if="submittedEdit && !$v.milestonesEdit.title.required" class="invalid-feedback">Title is required</div>
            </div>
            <div class="form-group">
              <label for="milestones-edit-description">Description</label>
              <textarea rows="3" v-model="milestonesEdit.description" id="milestones-edit-description" name="description" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.milestonesEdit.description.$error }" ></textarea>
              <div v-if="submittedEdit && !$v.milestonesEdit.description.required" class="invalid-feedback">Description is required</div>
            </div>
            <div class="form-group">
              <button class="btn btn-primary">Update</button>
            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import UserTasks from "./user-tasks";


  export default {
    name: "user-milestones",
    components: {
      UserTasks
    },
    data() {
      return {
        milestones_data: [],
        milestonesEdit: {
          title: "",
          description: ""
        },
        submittedEdit: false,
        renderComponent: true,
      }
    },
    validations: {
      milestonesEdit: {
        title: { required },
        description: { required }
      },
    },
    props: {
      user_milestones: {
        type: [Array, Object],
        default: undefined
      }
    },
    methods: {
      openEditModal(item) {
        this.milestonesEdit.name = item.title;
        this.milestonesEdit.title = item.title;
        this.milestonesEdit.description = item.description;
        this.milestonesEdit.userMilestoneId = item.id;

        this.$refs['edit-milestones'].show();
      },
      handleEdit() {
        this.submittedEdit = true;

        this.$v.milestonesEdit.$touch();
        if (this.$v.milestonesEdit.$invalid) {
          return;
        }

        this.milestonesEdit.name = this.milestonesEdit.title;

        this.$store.dispatch('editUserMilestones', this.milestonesEdit).then(() => {
          this.$toasted.show(' Successfully Changed ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['edit-milestones'].hide();
          this.milestones_data.forEach((val) => {
            if(val.id === this.milestonesEdit.userMilestoneId) {
              val.title = this.milestonesEdit.title;
              val.description = this.milestonesEdit.description;
            }
          })
        }).catch(() => {
          this.$toasted.show(' Please try again ', {
            theme: 'bubble',
            position: "top-right",
            type: 'error',
            duration: 2000
          });
        })
      },
      init() {
        this.milestones_data = this.user_milestones
      },
    },
    created() {
      this.init();
    }
  }
</script>

<style scoped lang="scss">
  .ghost {
    overflow: hidden;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background-color: #afe4ff;
    }
  }
  .milestones-card {
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .collapseicon-wrapper {
      background: rgb(246, 247, 251);
      padding: 20px 0;
      margin-bottom: 30px;
    }

    .btn-icon-center {
      padding: 0.375rem 14px;

      i {
        margin: 0 auto;
      }
    }

    .collapseicon-btn {
      background-color: #4466f2;
      border-color: #4466f2;
      color: #fff;
      i {
        transition: 0.5s;
        transform: rotate(90deg);
      }

      &.collapsed {
        border-color: #f6f7fb;
        background-color: transparent;
        color: #2a3142;
        i {
          transform: rotate(0deg);
        }
      }
    }
  }

  .isDragging {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background-color: #ffffff75;
  }

  .handle-drag {
    width: 40px;
    height: 100%;
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
    margin-right: 15px;

    i {
      font-size: 20px;
    }
  }

</style>
